module.exports = __webpack_public_path__ + "static/media/Kinematics of Machines.04795f87.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Kinematics of Machines.pdf
// module id = 138
// module chunks = 0